import { useCallback, useState } from 'react';
import axios from 'axios';

import { headers } from '../../../actions/defaults';
import { API_URL } from '../../../environment';

// Tracks phone dial-in participants for a video session. Returning false from
// onPhoneCallConnected tells the session hook not to subscribe to the stream.
export function useVoiceCalls() {
  const [voiceCalls, setVoiceCalls] = useState([]);

  const onPhoneCallConnected = useCallback(async connectionId => {
    try {
      const response = await axios.get(
        `${API_URL}/vonage_videos/voice_call_link?connection_id=${encodeURIComponent(
          connectionId,
        )}`,
        headers(),
      );
      const result = response.data;
      setVoiceCalls(calls => {
        if (
          calls.some(
            call =>
              call.video_session_connection_id ===
              result.video_session_connection_id,
          )
        ) {
          return calls;
        }

        return [...calls, result];
      });
      return true;
    } catch {
      return false;
    }
  }, []);

  const onPhoneCallDisconnected = useCallback(connectionId => {
    setVoiceCalls(calls =>
      calls.filter(call => call.video_session_connection_id !== connectionId),
    );
  }, []);

  return { voiceCalls, onPhoneCallConnected, onPhoneCallDisconnected };
}
